// Sensitive file
module.exports = {
    emailJS: {
        user_id: 'user_sPXEf7VXMx4gXmotIkLQc',
        service_id: 'portfoliowebgmail',
        template_id: 'template_ZJJcGKJW',
    },
}